var _path, _path2, _path3, _path4, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserMultiple(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "user--multiple",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_27288",
    "data-name": "Path 27288",
    d: "M26.938,24.75H25.813V21.938A2.816,2.816,0,0,0,23,19.125V18a3.942,3.942,0,0,1,3.938,3.938Z",
    transform: "translate(-10.063 -7.875)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27289",
    "data-name": "Path 27289",
    d: "M13.25,24.75H12.125V21.938a2.816,2.816,0,0,0-2.812-2.812H5.938a2.816,2.816,0,0,0-2.812,2.813V24.75H2V21.938A3.942,3.942,0,0,1,5.938,18H9.313a3.942,3.942,0,0,1,3.938,3.938Z",
    transform: "translate(-0.875 -7.875)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27290",
    "data-name": "Path 27290",
    d: "M20,2V3.125A2.813,2.813,0,0,1,20,8.75V9.875A3.937,3.937,0,1,0,20,2Z",
    transform: "translate(-8.75 -0.875)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27291",
    "data-name": "Path 27291",
    d: "M8.938,3.125A2.813,2.813,0,1,1,6.125,5.938,2.813,2.813,0,0,1,8.938,3.125M8.938,2a3.938,3.938,0,1,0,3.938,3.938A3.937,3.937,0,0,0,8.938,2Z",
    transform: "translate(-2.188 -0.875)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "_Transparent_Rectangle_",
    "data-name": "<Transparent Rectangle>",
    width: 18,
    height: 18,
    fill: "none"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserMultiple);
export default __webpack_public_path__ + "static/media/user-multiple.817d70f488dd991a039589640e5ecbd2.svg";
export { ForwardRef as ReactComponent };